<template>
  <div>
    <vs-button
      @click="faturaCiktiEvrak()"
      style="border-radius: 5px; padding-bottom: 0; padding-top: 0"
      color="success"
      type="gradient"
      icon="print"
      >Çıktı Al</vs-button
    >
  </div>
</template>
<script>
import state from "../../../../store/state";
import Store from "../../../../store/store";
export default {
  methods: {
    faturaCiktiEvrak(order) {
      var order = this.params.data.orderNumber;
      document.getElementById("ciktiPdf2").src =
        Store.state.printAddress +
        order +
        "&Tr=" +
        Store.state.uzum.faturaCiktisiPazaryeriVal;
    },
  },
};
</script>